import { useEffect, useRef } from "react";
import { SerializedStyles } from "@emotion/react";
import { Flexbox } from "../Flexbox";
import { useCameraKit } from "../../context/CameraKitContext";
import { canvasContainer } from "./CanvasContainer.styles";

interface CanvasContainerProps {
    canvasOutput: HTMLCanvasElement;
    containerStyle?: SerializedStyles;
    withFlexbox?: boolean;
}
export const CanvasContainer = ({ canvasOutput, containerStyle, withFlexbox = true }: CanvasContainerProps) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const { size } = useCameraKit();

    useEffect(() => {
        // Append the canvas element that is given to us from CameraKitSession's output property
        // so that we may begin viewing the output
        if (canvasRef.current && canvasOutput) {
            canvasRef.current.replaceWith(canvasOutput);
        }
    }, [canvasOutput]);

    // If we do not wish to use flexbox return basic styled div. For most use cases we will want it to
    // use flexbox but there are times such as with webrtc where this is not needed.
    if (!withFlexbox) {
        return (
            <div css={[canvasContainer, containerStyle]}>
                <div data-testid="canvas-container">
                    <canvas ref={canvasRef}></canvas>
                </div>
            </div>
        );
    }
    return (
        <Flexbox flexDirection="column" flex="1" alignItems="baseline" css={[canvasContainer, containerStyle]}>
            <div
                data-testid="canvas-container"
                style={{
                    maxWidth: 640,
                    maxHeight: 480,
                    aspectRatio: `${size?.width}/${size?.height}`,
                }}
            >
                <canvas ref={canvasRef}></canvas>
            </div>
        </Flexbox>
    );
};
